// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__12D19","label":"Section_label__1PEPx","contentWrap":"Section_contentWrap__24mPj","footer":"Section_footer__ZK2ZX","footerInner":"Section_footerInner__35gEh"};